import { Star } from "@phosphor-icons/react";
import { Badge } from "../ui/badge";
import { ScrollArea } from "../ui/scroll-area";
import { getOppItemClass, getTextPrimary, getTextSecondary } from "../../lib/styleHelpers";

export function RecentSidebar({
  opportunities,
  selectedOpportunity,
  setSelectedOpportunity,
  getProbabilityColor,
  watchlistIds,
  isDark,
}) {
  return (
    <div className={`rounded-xl p-4 border ${isDark ? "bg-[#12121a] border-white/10" : "bg-white border-gray-200"}`} data-testid="recent-opportunities">
      <h3 className={`font-bold mb-4 text-sm tracking-tight ${getTextPrimary(isDark)}`}>Recent Opportunities</h3>
      <ScrollArea className="h-[600px]">
        <div className="space-y-3">
          {opportunities.slice(0, 10).map((opp) => (
            <button
              key={opp.id}
              onClick={() => setSelectedOpportunity(opp)}
              className={`w-full text-left p-3 rounded-lg border transition-all ${getOppItemClass(selectedOpportunity?.id === opp.id, isDark)}`}
              data-testid={`opp-item-${opp.id}`}
            >
              <div className="flex items-center justify-between mb-1">
                <div className="flex items-center gap-1">
                  <Badge variant="outline" className={`text-[10px] ${isDark ? "border-purple-500/30 text-purple-300" : "border-purple-300 text-purple-600"}`}>
                    {opp.category?.split(" ")[0]}
                  </Badge>
                  {watchlistIds?.has(opp.id) && (
                    <Star size={12} weight="fill" className="text-amber-400" />
                  )}
                </div>
                <span className={`text-[10px] font-body ${getTextSecondary(isDark)}`}>
                  {new Date(opp.created_at).toLocaleDateString()}
                </span>
              </div>
              <p className={`text-sm font-medium line-clamp-2 ${getTextPrimary(isDark)}`}>{opp.title}</p>
              <div className="flex items-center gap-2 mt-2">
                <span className="text-xs font-bold" style={{ color: getProbabilityColor(opp.probability_score) }}>
                  {Math.round(opp.probability_score * 100)}%
                </span>
                <span className={`text-xs ${isDark ? "text-gray-600" : "text-gray-300"}`}>|</span>
                <span className="text-xs text-emerald-400">{opp.estimated_roi}</span>
              </div>
            </button>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}
